import { getUUID } from "./session";
import { identify, alias } from "../adapters/mixpanel";
/**
 * Checks if a /me API endpoint successfully returned User ID, or we don't
 * need the User ID (e.g. PWS SPA) because users have an anonymous access.
 * @returns
 */
export var isIdentityAvailable = function isIdentityAvailable() {
  var _window$user_context;
  // API /me endpoint returned a user ID for the RP, Student and Admin SPAs, or we
  // don't need the user ID for public SPAs (anonymous users)
  if ((_window$user_context = window.user_context) !== null && _window$user_context !== void 0 && _window$user_context.id || window.EVENT_TRACKER_IDENTITY === 'public') {
    return true;
  }
  // API /me endpoint hasn't responded yet (we didn't get User ID)
  return false;
};

/**
 * Creates a Temporary ID that is assinged to all the users (anonymous or autheticated). It is later
 * associated with a User ID (if a user sign up with ApplyBoard) to create a single user profile.
 *
 * NOTE: This Temporary ID is stored in localstorage.
 * @returns
 */
export var getTempId = function getTempId() {
  return getUUID();
};

/**
 * Identifies user by creating a single profile and also associate multiple IDs
 * into the single profile, if provided (e.g. User ID and Temporary ID).
 *
 * This method is when User ID becomes available or it is not required.
 *
 * NOTE: Temporary ID is created for the new unauthenticated users.
 * @param identity
 */
export var identifyUser = function identifyUser(identity) {
  var _window$user_context2, _identity$userInfo, _window$user_context3, _window$user_context4;
  var tempId = getTempId(); // temporary ID for anonymous users (stored in localstorage)

  // NOTE: The SPA's "index.html.ejs" page calls an /api/v2/me API endpoint which returns a
  //       'user_context' and it assigns it to the window object.
  var userId = (identity === null || identity === void 0 ? void 0 : identity.id) || ((_window$user_context2 = window.user_context) === null || _window$user_context2 === void 0 ? void 0 : _window$user_context2.id);
  var userType = (identity === null || identity === void 0 ? void 0 : (_identity$userInfo = identity.userInfo) === null || _identity$userInfo === void 0 ? void 0 : _identity$userInfo.role) || ((_window$user_context3 = window.user_context) === null || _window$user_context3 === void 0 ? void 0 : _window$user_context3.role);

  // First, try to identify user with its primary User ID, if exists (or it's an anonymous user)
  if (userId) {
    // Authenticated user
    identify(userId, {
      userType: userType // used for backward compatibility
    });
  } else {
    // Anonymous user that does not have a User ID (e.g. PWS SPA), so we're using a Temporary ID to identify user
    identify(tempId, {
      userType: 'unknown'
    });
  }

  // Second, associate another ID with the primary User ID
  if (identity !== null && identity !== void 0 && identity.id) {
    // A new registered user gets a new User ID which we associate with the previous created Temporary ID
    alias(tempId, identity.id);
  } else if ((_window$user_context4 = window.user_context) !== null && _window$user_context4 !== void 0 && _window$user_context4.id) {
    // User is autheticated and we're associating a Temporary ID with a User ID
    alias(window.user_context.id, tempId);
  }
};

/**
 * Returns User ID that was retrieved from a /me API endpoint.
 * @returns
 */
export var getUserId = function getUserId() {
  var _window$user_context5;
  return ((_window$user_context5 = window.user_context) === null || _window$user_context5 === void 0 ? void 0 : _window$user_context5.id) || 'unknown';
};

/**
 * Returns User Role that was retrieved from a /me API endpoint.
 * @returns
 */
export var getUserType = function getUserType() {
  var _window$user_context6;
  return ((_window$user_context6 = window.user_context) === null || _window$user_context6 === void 0 ? void 0 : _window$user_context6.role) || 'unknown';
};

/**
 * Tells whether the user is an RP owner vs staff
 * @returns
 */
export var getRpType = function getRpType() {
  var _window$user_context7;
  return ((_window$user_context7 = window.user_context) === null || _window$user_context7 === void 0 ? void 0 : _window$user_context7.agent_type) || 'unknown';
};

/**
 * Returns the agency id of the user
 * @returns
 */
//@ts-expect-error TODO: fix this
export var getAgentManagerId = function getAgentManagerId() {
  var _window$user_context8;
  return ((_window$user_context8 = window.user_context) === null || _window$user_context8 === void 0 ? void 0 : _window$user_context8.agent_manager_id) || 'unknown';
};

/**
 * Returns the sales tier of the user agency
 * @returns
 */
export var getAgencyTier = function getAgencyTier() {
  var _window$user_context9;
  return ((_window$user_context9 = window.user_context) === null || _window$user_context9 === void 0 ? void 0 : _window$user_context9.agency_tier) || 'unknown';
};